<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{
              $t('expenseItem.expenseCode')
            }}</label>
            <input
              v-model="model.exp_code"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('exp_code') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('exp_code')"
            >
              {{ errors.first('exp_code') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{
              $t('expenseItem.expenseItemCategory')
            }}</label>
            <a-select
              v-model.number="model.exp_cat_id"
              :options="category_options"
              class="ts-w-full"
            ></a-select>
            <div class="validate ts-text-xs" v-if="errors.has('exp_cat_id')">
              {{ errors.first('exp_cat_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{
              $t('expenseItem.expenseItem')
            }}</label>
            <input
              v-model="model.exp_item"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('exp_item') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('exp_item')"
            >
              {{ errors.first('exp_item') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{
              $t('expenseItem.uomCategory')
            }}</label>
            <a-select
              v-model.number="model.uom_cat_id"
              :options="uom_category_options"
              class="ts-w-full"
            ></a-select>
            <div class="validate ts-text-xs" v-if="errors.has('uom_cat_id')">
              {{ errors.first('uom_cat_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs">{{
              $t('expenseItem.expenseDescription')
            }}</label>
            <textarea
              v-model="model.exp_desc"
              rows="3"
              class="form-control"
            ></textarea>
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('exp_desc')"
            >
              {{ errors.first('exp_desc') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-mt-3 text-right">
            <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button
              v-if="!isUpdate"
              color="primary"
              outline
              :waiting="waiting_new"
              :disabled="waiting || waiting_new"
              @click.prevent="onSaveAddNew"
            >
              {{ $t('saveAddNew') }}</ts-button
            >
            <ts-button
              class="ts-ml-2"
              color="primary"
              v-if="!isUpdate"
              :waiting="waiting"
              :disabled="waiting_new || waiting"
              @click.prevent="onSave"
            >
              {{ $t('save') }}</ts-button
            >
            <ts-button
              v-if="isUpdate"
              color="primary"
              @click.prevent="onUpdate"
              :waiting="waiting"
              >{{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'expenseItem',
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      category_options: [],
      uom_category_options: [],
      employee_options: [],
      model: {
        exp_id: 0,
        exp_cat_id: null,
        exp_code: null,
        exp_item: null,
        exp_desc: null,
        uom_cat_id: null
      }
    }
  },
  async created() {
    await this.getPreData()
    await this.setEditData()
  },
  computed: {
    ...mapState('expense/expenseItem', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onSaveAddNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.$store
        .dispatch('expense/expenseItem/store', this.model)
        .then(response => {
          this.notice({
            type: 'success',
            text: response.message
          })
            this.$emit('fetchData')
            this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('expense/expenseItem/store', this.model)
        .then(response => {
          this.notice({
            type: 'success',
            text: response.message
          })
          this.$emit('cancel')
          this.$emit('fetchData')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('expense/expenseItem/update', {
          id: this.model.exp_id,
          data: this.model
        })
        .then(response => {
          this.notice({
            type: 'success',
            text: response.message
          })
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.exp_id = this.edit_data.exp_id
        this.model.exp_cat_id = this.edit_data.exp_cat_id
        this.model.exp_code = this.edit_data.exp_code
        this.model.exp_item = this.edit_data.exp_item
        this.model.exp_desc = this.edit_data.exp_desc
        this.model.uom_cat_id = this.edit_data.uom_cat_id
      }
    },
    clearInput() {
      this.errors = new Errors()
      this.model.exp_id = 0
      this.model.exp_cat_id = null
      this.model.exp_code = null
      this.model.exp_item = null
      this.model.exp_desc = null
      this.model.uom_cat_id = null
    },
    async getPreData() {
      this.loading = true
      await this.$store
        .dispatch('expense/expenseItem/getUomCategory')
        .then(response => {
          this.uom_category_options = response.data.map(el => ({
            value: el.uom_cat_id,
            label: el.uom_cat_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      await this.$store
        .dispatch('expense/expenseItem/getCategory')
        .then(response => {
          this.category_options = response.data.map(el => ({
            value: el.exp_cat_id,
            label: el.exp_category
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    notice(not) {
      this.$Notice[not.type]({
        title: 'EXPENSE ITEM',
        desc: not.text
      })
    }
  }
}
</script>
